import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { IProgramsState, IStepOne } from './types/StepOne-interface'

const StepOneState = (state: RootState): IStepOne => state.stepOneCancer

export const FormFieldsStepOne = createSelector(
    [StepOneState],
    (state): IStepOne => state,
)

export const Programs = createSelector(
    [StepOneState],
    (state): IProgramsState => state.Programs,
)

